import { useBoolean } from '@chakra-ui/react';
import React from 'react';
import FileViewer from '../../components/pdf_viewer/FileViewer';
import { EyeAvatarIcon } from '../../constants/IconData';
import { getDocumentViewerPath } from '../../components/pdf_viewer/documentViewer.utils';

const AccountsFileViewer = ({ fileLink }) => {
  const [isFileOpen, ifoState] = useBoolean(false);
  return (
    <React.Fragment>
      <EyeAvatarIcon style={{ cursor: 'pointer' }} onClick={ifoState.on} />
      <FileViewer
        isOpen={isFileOpen}
        currentFile={fileLink?.file_obj}
        attachments={fileLink?.attachments}
        viewerPath={getDocumentViewerPath({ chartId: fileLink?.id })}
        chartId={fileLink?.upload_id || fileLink?.file_id || fileLink?.id}
        onClose={ifoState.off}
      />
    </React.Fragment>
  );
};

export default AccountsFileViewer;
